import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/61/thumb-landscape.jpg"

const Post61 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">
        CHANEL／ボーイシャネルチェーンショルダーバッグ／W11× H9× D13 (cm)
      </span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>秋の風が心地よくなる10月。</p>
          <p>街にはブーツやニット、チェック柄など秋らしいアイテムが並び、季節感あふれるファッションを楽しめる時期になりました。そんな秋コーデに「もう少し洗練さをプラスしたい」と思ったとき、ぜひ取り入れたいのが少し小さめのCHANEL（シャネル）のチェーンショルダーバッグです。</p>
          <p>コンパクトすぎて、スマートフォンすら入らないサイズ感ですが、それこそが魅力です。収納力よりも、アクセサリー感覚で持てる特別なバッグとして注目を集めています。リップやワイヤレスイヤホンなど小物だけを入れて、アクセサリーのように身につけることで、秋の装いを格上げしてくれるアイテムです。</p>
          <p>この記事では、「10月にCHANELミニバッグを選ぶ理由」と「秋コーデに映えるスタイル」を徹底解説します。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;CHANELミニチェーンショルダーの魅力を徹底解説</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec2" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ココ・シャネルが生んだ“自由の象徴”</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec3" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;CHANELアイコンが凝縮されたデザイン</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec4" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;必要最小限だからこそスタイリッシュ</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec5" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;アクセサリー感覚で持てるCHANELミニバッグ</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;秋コーデに合わせたいCHANELミニバッグスタイル</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec7" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ツイードとデニムを融合した大人の洗練カジュアル</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec8" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ベージュ×ブラックで魅せる大人の秋スタイル</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec9" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;秋の休日を軽やかに楽しむスポーティ×エレガンススタイル</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec10" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;知的なブラックを主役にしたクラシカルな秋冬スタイル</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec11" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;パリジェンヌ風シックなモノトーンスタイル</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec12" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;まとめ：10月のおしゃれにCHANELミニチェーンショルダーを</ScrollLink><br></br>
          </div>
        </p>
      </div>
      <section name="sec1" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/61/1.jpg" alt=""/>
          <span className="text-center">CHANEL／MATELASSE チェーンショルダーバッグ／W10× H11× D2 (cm)</span>
        </figure>
        <div className="mt8">
          <h2>CHANELミニチェーンショルダーの魅力を徹底解説</h2>
        </div>
        <p>秋の街に映える装いを完成させてくれるのは、さりげなくも確かな存在感を放つ「CHANEL（シャネル）」のミニチェーンショルダーです。手のひらサイズながら、気品と自信を纏わせてくれるその佇まいは、まさに“特別な日常”を演出してくれるアイテムです。コーディネートに取り入れるだけで、エレガントで女性らしい雰囲気をプラスできるのも魅力です。</p>
        <p>そんなCHANELミニチェーンショルダーには、創業者ココ・シャネルの想いやブランドの美学が細部にまで息づいています。ここからは、その歴史やデザインの背景をひもときながら、ミニチェーンショルダーがなぜ多くの女性に愛され続けているのか、その魅力を詳しくご紹介します。</p>
        <div name="sec2" className="text-img-cloumn-main mt8">
          <figure>
            <StaticImage src="../../images/posts/61/2.jpg" alt=""/>
          </figure>
          <div>
            <h3>1. ココ・シャネルが生んだ“自由の象徴”</h3>
            <p>創業者ココ・シャネルは「女性の両手を解放したい」という想いから、肩に掛けられるチェーンバッグを発明しました。その精神を受け継ぐミニチェーンショルダーは、小さなフォルムの中に自由さと洗練が凝縮されています。今もなお、世界中の女性に愛され続けています。</p> 
          </div>
        </div>
        <div name="sec3" className="text-img-cloumn-main reverse">
          <figure>
            <StaticImage src="../../images/posts/61/3.jpg" alt=""/>
          </figure>
          <div>
            <h3>2. CHANELアイコンが凝縮されたデザイン</h3>
            <p>マトラッセのキルティング、ココマーク、チェーンストラップは、どれもCHANELを象徴する要素がしっかりと詰め込まれています。小さくてもラグジュアリー感が損なわれることはなく、むしろサイズが小さいからこそデザインの美しさが際立ちます。</p> 
          </div>
        </div>
        <div name="sec4" className="text-img-cloumn-main">
          <figure>
            <StaticImage src="../../images/posts/61/4.jpg" alt=""/>
          </figure>
          <div>
            <h3>3. 必要最小限だからこそスタイリッシュ</h3>
            <p>リップ、ワイヤレスイヤホン程度しか入らないけれど、それが魅力です。「必要以上に持たない」シンプルなライフスタイルを象徴するバッグとして、現代的なスタイルにフィットします。</p> 
          </div>
        </div>
        <div name="sec5" className="text-img-cloumn-main reverse">
          <figure>
            <StaticImage src="../../images/posts/61/5.jpg" alt=""/>
          </figure>
          <div>
            <h3>4. アクセサリー感覚で持てるCHANELミニバッグ</h3>
            <p>ネックレスやブレスレットのように、スタイル全体を引き締める役割を果たします。特に10月は、ニットやアウターの厚みを軽やかに見せてくれる効果が抜群です。</p> 
          </div>
        </div>
      </section>
      <section name="sec6" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/61/6.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>秋コーデに合わせたいCHANELミニバッグスタイル</h2>
        </div>
        <p>秋はニットやツイード、ウールなど重厚感のある素材が主役になり、コーディネート全体がボリュームアップします。そこに小さなCHANELミニバッグを合わせると、絶妙なバランスで軽やかさと華やかさを演出できます。</p>
        <ul className="list-style-disc" style={{marginTop: "2rem"}}>
          <li>斜め掛けできるので秋アウターとも好相性◎</li>
          <li>チェーンの煌めきがアクセサリーのように映える◎</li>
          <li>小さいからこそデザイン性が際立ち、主役級の存在感を放つ◎</li>
        </ul>
        <p>バッグというよりもジュエリー感覚で楽しめるのが、秋にCHANELミニバッグを持つ大きな理由です。</p>
        <div className="border"></div>
        <div name="sec7">
          <h3>◆ ツイードとデニムを融合した大人の洗練カジュアル</h3>
        </div>
        <h4>【BOY CHANEL チェーンショルダーバッグ】W10× H8× D3 (cm)</h4>
        <div className="text-img-cloumn-main">
          <figure>
            <StaticImage src="../../images/posts/61/7.jpg" alt=""/>
          </figure>
          <div>
            <h5><span className="text-border-bottom">おすすめコーディネート</span></h5>
            <p>秋の立ち上がりに最適な、ツイードのベストを主役にしたコーディネートです。ワイドデニムに、ツイードのVネックベストというクラシックなアイテムを重ねることで、一気に知的な大人の装いに格上げします。ボリュームのあるローファーが、全体のバランスを引き締め、マニッシュな秋のムードを強調しています。この洗練されたミックススタイルに、BOY CHANELの力強いデザインがマッチし、太めのチェーンと金具が、ツイードやローファーのマニッシュな要素を強調しています。パールネックレスの柔らかな光で女性らしい優雅さを加える、絶妙なバランスが魅力のコーディネートです。</p>
            <h5><span className="text-border-bottom">おすすめのシーン</span></h5>
            <p>知的な刺激を求める秋の休日にぴったりです。美術館やギャラリーのオープニング、話題の書店でのイベント、落ち着いたホテルのラウンジでのミーティングなど、デニムスタイルでも品格とファッション感度を両立させたいシーンにおすすめです。</p>
          </div>
        </div>
        <div className="text-img-cloumn-main reverse">
          <figure>
            <StaticImage src="../../images/posts/61/8.jpg" alt=""/>
          </figure>
          <div>
            <h5><span className="text-border-bottom">アイコンバッグのBOY CHANEL</span></h5>
            <p>小さめのBOY CHANELは、タフなデザインを活かしたアクセサリーバッグとして最適です。「BOY CHANEL」は、ココ・シャネルが大切にしていた“自由な精神”を象徴するバッグです。構築的でモダンなフォルムは、どんなスタイルにも自信を与えてくれます。マトラッセのステッチと重厚なゴールドチェーンが特徴的です。ツイードとブラックの組み合わせが秋の空気にしっくりと馴染みます。</p>
          </div>
        </div>
        <div name="sec8" className="mt8">
          <h3>◆ ベージュ×ブラックで魅せる大人の秋スタイル</h3>
        </div>
        <h4>【MATELASSE チェーンショルダーバッグ】W10× H11× D2 (cm)</h4>
        <div className="text-img-cloumn-main">
          <figure>
            <StaticImage src="../../images/posts/61/9.jpg" alt=""/>
          </figure>
          <div>
            <h5><span className="text-border-bottom">おすすめコーディネート</span></h5>
            <p>リラックス感のある黒のオールインワンに、ベージュのショートトレンチコートを羽織ることで、都会的でシックな大人のカジュアルスタイルが完成します。マトラッセは、そのクラシックなデザインをあえてカジュアルなアウターと組み合わせることで、エレガントなムードを損なわず、絶妙なミックス感を演出します。足元のスパンコールシューズが歩くたびに煌めき、シックなブラックコーデに遊び心をプラスします。首元に巻いた柄スカーフが視線を上げ、手元のゴールドウォッチとも相性抜群で、秋の大人スタイルを完成させます。</p>
            <h5><span className="text-border-bottom">おすすめのシーン</span></h5>
            <p>ラグジュアリーな場所での社交的なシーンにおすすめです。ホテルでのアフタヌーンティー、ウィンドウショッピングやランチ、ドレスコードに迷うカジュアルめのディナーデートなど、活動的でありながら上質さが求められるシーンにぴったりです。</p>
          </div>
        </div>
        <div className="text-img-cloumn-main reverse">
          <figure>
            <StaticImage src="../../images/posts/61/10.jpg" alt=""/>
          </figure>
          <div>
            <h5><span className="text-border-bottom">ドラマティックなバッグMATELASSE</span></h5>
            <p>コンパクトなサイズ感のマトラッセは、もはやジュエリーのような存在感を放ちます。伝統的なキルティングとゴールドのCCマーク、チェーンが、日常のカジュアルスタイルを瞬時に格上げしてくれる、「アクセサリー感覚」で楽しむためのバッグです。ドラマティックなバッグは周囲の視線を集めます。</p>
          </div>
        </div>
        <div name="sec9" className="mt8">
          <h3>◆ 秋の休日を軽やかに楽しむスポーティ×エレガンススタイル</h3>
        </div>
        <h4>【MATELASSE チェーンショルダーバッグ】W12× H12× D5 (cm)</h4>
        <div className="text-img-cloumn-main">
          <figure>
            <StaticImage src="../../images/posts/61/11.jpg" alt=""/>
          </figure>
          <div>
            <h5><span className="text-border-bottom">おすすめコーディネート</span></h5>
            <p>グレーのスエットパーカーとスカートに、ベージュのフェイクファーベストを重ねた柔らかな印象の秋コーデです。足元はボリュームスニーカーで抜け感を出しつつ、全体を軽やかにまとめています。そこに、CHANELのマトラッセをプラスすれば、一気に大人の上品さがアップします。小ぶりながらもキルティングレザーの艶感とゴールドチェーンの輝きが、ラフな装いにほどよい高級感を添えます。</p>
            <h5><span className="text-border-bottom">おすすめのシーン</span></h5>
            <p>リラックス感を重視したい週末の活動におすすめです。隣町の話題のスポットへのドライブや自然の中での軽めのウォーキング、週末のファミリーでのカジュアルな集まりなどにぴったりです。スニーカー合わせでも“きちんと感”を演出できるため、アクティブな中にも優雅さを忘れないスタイルです。</p>
          </div>
        </div>
        <div className="text-img-cloumn-main reverse">
          <figure>
            <StaticImage src="../../images/posts/61/12.jpg" alt=""/>
          </figure>
          <div>
            <h5><span className="text-border-bottom">レザーフリルが可愛いMATELASSE</span></h5>
            <p>コーディネート全体を淡いトーンでまとめたときこそ、バッグのブラックカラーが引き締め役になります。シャネルならではのマトラッセステッチとココマークが、シンプルなカジュアルスタイルをワンランク上へと導きます。チェーンのトップにはレザーフリルが装飾されていて、秋の装いに上品さと可愛らしさという魅力的なアクセントを加えたいときに最適な一品です。</p>
          </div>
        </div>
        <div name="sec10" className="mt8">
          <h3>◆ 知的なブラックを主役にしたクラシカルな秋冬スタイル</h3>
        </div>
        <h4>【MATELASSE チェーンショルダーバッグ】W10× H10× D3 (cm)</h4>
        <div className="text-img-cloumn-main">
          <figure>
            <StaticImage src="../../images/posts/61/13.jpg" alt=""/>
          </figure>
          <div>
            <h5><span className="text-border-bottom">おすすめコーディネート</span></h5>
            <p>ニットワンピースが作る縦のラインに、フェアアイル柄のカーディガンを羽織れば、温かみのあるクラシックな秋冬のムードが完成します。足元のブーツは、ワンピースの裾から覗く肌面積を減らし、ぐっと洗練された印象になります。 仕上げにマトラッセを添えることで、カジュアルなニットスタイルに高級感と品格が加わります。カーキのニット帽やメガネなどの小物使いで、ファッション感度の高さをアピールできる、シックながらも遊び心のある着こなしです。</p>
            <h5><span className="text-border-bottom">おすすめのシーン</span></h5>
            <p>ゆったりと時間を過ごしたい週末の活動におすすめです。肌寒い季節の紅葉狩りや景色を楽しむ少し遠出のドライブデート、落ち着いたブックカフェでの読書など、リラックス感がありつつも、上品さを保ちたいシーンにぴったりです。</p>
          </div>
        </div>
        <div className="text-img-cloumn-main reverse">
          <figure>
            <StaticImage src="../../images/posts/61/14.jpg" alt=""/>
          </figure>
          <div>
            <h5><span className="text-border-bottom">知的なブラックバッグMATELASSE</span></h5>
            <p>コンパクトなマトラッセは、「アクセサリーバッグ」として、エレガントなムードを添えるのにぴったりです。スマートフォンさえ入らないことが多いこのサイズは、実用性よりも、クラシックなデザインをジュエリー感覚で楽しむためのアイテムとして、着こなしの完成度を高めます。</p>
          </div>
        </div>
        <div name="sec11" className="mt8">
          <h3>◆ パリジェンヌ風シックなモノトーンスタイル</h3>
        </div>
        <h4>【MATELASSE チェーンショルダーバッグ】W11× H7× D2 (cm)</h4>
        <div className="text-img-cloumn-main">
          <figure>
            <StaticImage src="../../images/posts/61/15.jpg" alt=""/>
          </figure>
          <div>
            <h5><span className="text-border-bottom">おすすめコーディネート</span></h5>
            <p>モノトーンを基調に、ドット柄ブラウスとツイードジャケットというクラシックなアイテムを組み合わせることで、上品で女性らしい雰囲気を醸し出します。ボトムスはミニ丈、足元は黒のロングブーツで肌の露出を抑えつつ、旬のバランスを意識したスタイルです。小さなマトラッセを合わせることで、シックな装いを格段にラグジュアリーに格上げします。耳元で揺れるパール調のドロップピアスが女性らしさを引き立て、ベレー帽をプラスすれば、パリジェンヌのような洗練されたムードが完成します。</p>
            <h5><span className="text-border-bottom">おすすめのシーン</span></h5>
            <p>華やかさとエレガントさを重視したいシーンに最適です。レストランでのカジュアルなディナー、美術館や劇場での芸術鑑賞、ブティックでのショッピングなど、洗練された場所でファッション性を両立させたいときにぴったりです。</p>
          </div>
        </div>
        <div className="text-img-cloumn-main reverse">
          <figure>
            <StaticImage src="../../images/posts/61/16.jpg" alt=""/>
          </figure>
          <div>
            <h5><span className="text-border-bottom">レディーなMATELASSE</span></h5>
            <p>マトラッセは、レディーなムードを演出するのにぴったりです。実用的な収納力はありませんが、クラシックなデザインを究極のアクセサリーとして、着こなしのアクセントにするアイテムです。バッグのキルティングレザーの光沢とゴールドの煌めきが、装いの重心となり、一気にクラス感を引き上げます。</p>
          </div>
        </div>
      </section>
      <section name="sec12" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/61/17.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>まとめ：10月のおしゃれにCHANELミニチェーンショルダーを</h2>
        </div>
        <p>秋はファッションを存分に楽しめる季節。<br></br>
        そんな時期こそ、小さなCHANELミニチェーンショルダーを取り入れることで、コーデ全体の完成度がぐっと高まります。</p>
        <p>スマートフォンが入らないほどのサイズ感だからこそ、バッグというよりアクセサリーとしての価値が際立つアイテムです。ココ・シャネルが掲げた「女性を自由にする」スタイルを、現代に軽やかに表現できるバッグです。</p>
        <p>この10月は、あなたの秋コーデにCHANELミニバッグを取り入れて、特別感のある大人のおしゃれを楽しんでみてはいかがでしょうか。</p>
        <div className="border"></div>
        <p>📱憧れを日常に──ラクサスでシャネルを体験しよう！</p>     
        <Link to="https://laxus.co/app/pc/bags/chanel" className="view-all-button">シャネルのバッグはこちら</Link>
      </section>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post61

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 61}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`